import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useState } from 'react';
import { useTheme } from '@emotion/react';
import { AppIcon } from '../icons';
import { Button } from './icon_button.styles';
import Label from '../typography/label';
function passthroughEventHandler(callback, passthroughFn) {
    return (e) => {
        callback(e);
        if (passthroughFn) {
            passthroughFn(e);
        }
    };
}
export const IconButton = ({ iconName, label, hoverFill, fill, slashcolor, disabledFillOverride, size, iconSize = null, onMouseEnter, onMouseLeave, disabled, buttonRef, fillLevel, ...buttonProps }) => {
    const theme = useTheme();
    const [hovered, setHovered] = useState(false);
    const color = hovered && hoverFill ? hoverFill : fill ? fill : theme.colors.grey90;
    return (_jsxs(Button, { "data-testid": iconName + '-icon-button', ref: buttonRef, onMouseEnter: passthroughEventHandler(() => setHovered(true), onMouseEnter), onMouseLeave: passthroughEventHandler(() => setHovered(false), onMouseLeave), size: size, disabled: disabled, type: "button", ...buttonProps, children: [_jsx(Label, { screenReaderOnly: true, children: label }), _jsx(AppIcon, { name: iconName, filllevel: fillLevel, color: disabled && disabledFillOverride
                    ? disabledFillOverride
                    : disabled
                        ? theme.colors.grey30
                        : color, slashcolor: slashcolor, size: size, iconSize: iconSize })] }));
};
//# sourceMappingURL=icon_button.js.map